import * as Sentry from '@sentry/react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ICON_SIZE } from '../design-system';
import ErrorDetails from './ErrorDetails';

function FeatureFallback({ error, resetError }) {
  const { t } = useTranslation('common');

  return (
    <div className="rds-empty feature-fallback">
      <div className="rds-empty-header">
        <span className="rds-empty-media" aria-hidden="true">
          <AlertTriangle size={ICON_SIZE.xl} />
        </span>
        <p className="rds-empty-title">{t('errors.somethingWentWrong')}</p>
      </div>

      {/* Error details — visible so users can act and report bugs */}
      <ErrorDetails error={error} onRetry={resetError} />
    </div>
  );
}

export default function FeatureBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={FeatureFallback} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
